import parsePhoneNumber from 'libphonenumber-js'
import { IUserContactData } from '../../interfaces/auth'

// email validator
export const validateEmail = (value: string) => {
  return /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/.test(
    value
  )
}

// phone validator
export const validatePhone = (value: string) => {
  const numberParsed = parsePhoneNumber(value)
  return numberParsed?.isValid()
}

// validate if is number
export const validateNumber = (value: string | number) => {
  return /^[0-9]+$/.test(value?.toString() || '')
}

// validate if value is a number or ,
export const validateNumberFormatInput = (value: string | number) => {
  return /^[0-9,]+$/.test(value?.toString() || '')
}

// validate social username
export const validateSocialUsername = (value: string) => {
  return value && value !== undefined && value !== '' && value.length > 2
}

// validate signup form
export const validateSignupForm = (data: IUserContactData) => {
  const validate = [
    {
      value: data.firstName,
      error: 'First name is required',
    },
    {
      value: data.lastName,
      error: 'Last name is required',
    },
    {
      value: data.username,
      error: 'Username is required',
    },
    {
      value: data.email,
      error: 'Email is required',
    },
  ]

  return validate.find((v) => !v.value)
}
